import { PaginationType } from 'common';
import { AppRootStateType } from 'state/reducers';
import { CompanyType } from 'state/reducers/companies/types';

export const selectCompanies = (state: AppRootStateType): CompanyType[] =>
  state.companies.companies;
export const selectCompaniesSearch = (state: AppRootStateType): string | undefined =>
  state.companies.search;
export const selectCompaniesPagination = (state: AppRootStateType): PaginationType => ({
  page: state.companies.page,
  count: state.companies.count ?? 0,
});
export const selectCompaniesIsLoading = (state: AppRootStateType): boolean =>
  state.companies.isLoading;

export const selectCertainCompany = (state: AppRootStateType): CompanyType =>
  state.companies.certainCompany;
